// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfMonth as fn } from "../endOfMonth.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfMonthWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default endOfMonthWithOptions;
